import React, { useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import { Link, useNavigate } from 'react-router-dom'

export default function RegisterCompleted() {
   const { t } = useTranslation('UNAUTHORIZED')
   const navigate = useNavigate()

   useEffect(() => {
      setTimeout(() => navigate('/'), 5000)
   }, [])

   return (
      <Box
         sx={{
            flex: 1,
            height: '100%',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            pt: '10%',
            alignItems: 'center',
         }}
      >
         <Typography variant="h3" color="primary">
            {t('registerComplete.summaryTitle')}
         </Typography>
         <Typography align="center" variant="h5">
            {t('registerComplete.summaryMsg')}
         </Typography>
         <Typography align="center" variant="h5">
            {t('registerComplete.redirect')}
         </Typography>
         <ContainedButton variant="contained" size="large" type="submit">
            <Link to="/" style={{ color: 'white', textDecoration: 'none' }}>
               {t('registerComplete.loginButton')}
            </Link>
         </ContainedButton>
      </Box>
   )
}
